import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'show-loader',
  templateUrl: './show-loader.component.html',
  styleUrls: ['./show-loader.component.css']
})
export class ShowLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
